import '@/icons/bwi/all-bwi.css'
import '@fontsource-variable/inter'
import '@/css/app.css'

import { createInertiaApp, router } from '@inertiajs/react'
import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import ErrorBoundary from '@/components/error-boundary.js'

declare global {
  interface Window {
    _hsq: any[]
    HubSpotConversations?: {
      widget: {
        refresh: () => void
      }
    }
  }
}

createInertiaApp({
  resolve: (name: string) => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx')),
  setup({ el, App, props }: { el: HTMLElement; App: any; props: any }) {
    if (!import.meta.env.DEV) {
      router.on('navigate', (event) => {
        if (typeof window === 'undefined') return

        const { url } = event.detail.page
        const _hsq = (window._hsq = window._hsq || [])
        _hsq.push(['setPath', url])
        _hsq.push(['trackPageView'])

        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh()
        }
      })
    }

    // this code must be same as block in ssr.tsx
    const app = (
      <ErrorBoundary>
        <App {...props} />
      </ErrorBoundary>
    )
    // similarities end here

    if (import.meta.env.DEV) {
      createRoot(el).render(app)
    } else {
      hydrateRoot(el, app)
    }
  },
})
